
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.41 13c-.22 0-.45-.07-.67-.12-.445-.1-.883-.23-1.31-.39a2 2 0 00-2.48 1l-.22.46a13.173 13.173 0 01-2.67-2 13.168 13.168 0 01-2-2.67l.46-.21a2 2 0 001-2.48c-.159-.43-.289-.872-.39-1.32-.05-.22-.09-.45-.12-.67a3 3 0 00-3-2.49H5a3 3 0 00-2.24 1 3 3 0 00-.73 2.4 19.07 19.07 0 005.41 11 19.07 19.07 0 0011 5.41c.13.01.26.01.39 0a3 3 0 002.74-1.773 3 3 0 00.26-1.227v-3A3 3 0 0019.41 13zm.49 6a1 1 0 01-.712.957 1.001 1.001 0 01-.438.033 17.16 17.16 0 01-9.87-4.84A17.16 17.16 0 014 5.25a1 1 0 01.59-1.065A1 1 0 015 4.1h3a1 1 0 011 .78c0 .27.09.55.15.82a11 11 0 00.46 1.54l-1.4.66a1 1 0 00-.52.56 1 1 0 000 .76 14.49 14.49 0 007 7 1 1 0 00.76 0 1 1 0 00.56-.52l.63-1.4a12.42 12.42 0 002.39.61 1 1 0 01.78 1L19.9 19z","fill":"#ED4A68"}}),_c('path',{attrs:{"d":"M13.3 2h.7a8 8 0 017.99 8v.7a1 1 0 01-1 .91h-.08a1 1 0 01-.91-1.08V10a6 6 0 00-6-6h-.53a1.004 1.004 0 01-.17-2z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M16.293 10.707A1 1 0 0116 10a2 2 0 00-2-2 1 1 0 110-2 4 4 0 014 4 1 1 0 01-1.707.707z","fill":"currentColor"}})])
          )
        }
      }
    